import { Skeleton, SkeletonGroup } from "../Skeleton";
import { Spinner } from "../Spinner";
import "./loading.css";

export function LoadingActivity({ label = "Updating…" }: { label?: string }) {
  return <span className="bw-loading-activity" role="status"><Spinner />{label}</span>;
}

/** Same row height, thumbnail and text columns as the collection being opened. */
export function ListSkeleton({ label = "Loading posts", rows = 5 }: { label?: string; rows?: number }) {
  return <SkeletonGroup label={label} className="bw-loading-list">
    {Array.from({ length: rows }, (_, index) => <div key={index} className="bw-loading-row">
      <Skeleton width={48} height={48} radius={8} />
      <div className="bw-loading-text"><Skeleton width="65%" height={16} /><Skeleton width="40%" height={12} /></div>
      <div className="bw-loading-state"><Skeleton width={72} height={24} radius={999} /><Skeleton width={88} height={12} /></div>
    </div>)}
  </SkeletonGroup>;
}

export function FieldsSkeleton({ label = "Loading settings" }: { label?: string }) {
  return <SkeletonGroup label={label} className="bw-loading-fields">
    {Array.from({ length: 3 }, (_, index) => <div key={index}><Skeleton width="28%" height={14} /><Skeleton height={44} /><Skeleton width="65%" height={12} /></div>)}
  </SkeletonGroup>;
}

/** The writing page's strip and paper, without a focusable editor until its words arrive. */
export function PostSkeleton() {
  return <SkeletonGroup label="Loading post" className="bw-loading-post">
    <div className="bw-loading-post-strip"><Skeleton width={72} height={24} radius={999} /><Skeleton width={150} height={14} /><Skeleton width={96} height={36} /></div>
    <div className="bw-loading-paper"><Skeleton width="70%" height={36} />
      <Skeleton width="95%" height={16} /><Skeleton width="90%" height={16} /><Skeleton width="80%" height={16} />
      <Skeleton height={160} /><Skeleton width="95%" height={16} /><Skeleton width="75%" height={16} />
    </div>
  </SkeletonGroup>;
}
